// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Embed_Wrapper__UoACn"};